// extracted by mini-css-extract-plugin
export default {"inputMinutes":"TrackTime_inputMinutes__Y0hpq","inputLabel":"TrackTime_inputLabel__WJU+r"};